import React, { useEffect, useState } from "react";
import NavigationDrawer from "../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import TextInput from "../../components/textInput";
import { Box, Button, Paper, Stack } from "@mui/material";
import { APP_ICONS } from "../../assets";
import { getJobs } from "../../services/jobs";
import AppLoader from "../../components/loader/loader";
import GroupJob from "./GroupJob";
import GroupJobTable from "./GroupJobTable";

const Bookings = () => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("bookingSearchValue") || ""
  );
  const [activeTab, setActiveTab] = useState(0);
  const [viewTab, setViewTab] = useState(0); // 0 = Calendar View, 1 = Table View
  const [jobsData, setJobsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllJobs();
  }, []);

  useEffect(() => {
    filterJobs();
  }, [jobsData, searchValue]);

  const fetchAllJobs = async () => {
    try {
      setLoading(true);
      const response = await getJobs();
      if (response.data.status === "success") {
        setJobsData(response.data.data);
      } else {
        console.error("Fetch error:", response.data?.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter only by jobId
  const filterJobs = () => {
    if (searchValue) {
      const filtered = jobsData.filter((job) =>
        job.jobId?.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(jobsData);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    localStorage.setItem("bookingSearchValue", value);
  };

  const renderTabButton = (id, label) => {
    const isActive = activeTab === id;
    return (
      <Button
        key={id}
        variant="tab_button"
        sx={isActive ? useStyle.activeTab : useStyle.inActiveTab}
        onClick={() => setActiveTab(id)}
      >
        {label}
      </Button>
    );
  };

  return (
    <NavigationDrawer>
      <CustomBar title={"JOBS"} />
      <AppLoader isVisible={loading} />

      {/* View Tabs */}
      <Box sx={{ display: "flex", gap: 2, mb: 3, px: 2 }}>
        <Button
          variant="tab_button"
          sx={viewTab === 0 ? useStyle.activeTab : useStyle.inActiveTab}
          onClick={() => setViewTab(0)}
        >
          Calendar View
        </Button>
        <Button
          variant="tab_button"
          sx={viewTab === 1 ? useStyle.activeTab : useStyle.inActiveTab}
          onClick={() => setViewTab(1)}
        >
          Table View
        </Button>
      </Box>

      {/* Conditional Rendering */}
      {viewTab === 0 ? (
        <Paper>
          <GroupJob />
        </Paper>
      ) : (
        <Paper>
          <Stack
            px={3}
            py={2}
            gap={2}
            direction={{ md: "row" }}
            alignItems={"center"}
          >
            <TextInput
              sx={{ flex: 1 }}
              placeholder={"Search by jobId Code"}
              InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
              value={searchValue}
              onChange={handleSearchChange}
            />
          </Stack>
          <GroupJobTable tableData={filteredData} />
        </Paper>
      )}
    </NavigationDrawer>
  );
};

export default Bookings;

const useStyle = {
  activeTab: {
    bgcolor: "primary.main",
    color: "secondary.light",
    width: { xs: "100%", md: "auto" },
    px: 3,
    py: 1,
  },
  inActiveTab: {
    bgcolor: "secondary.light",
    color: "customColor.tundora",
    width: { xs: "100%", md: "auto" },
    px: 3,
    py: 1,
  },
};
